import { AxiosRequestConfig } from "axios"

import URLS from "~/constants/urls"
import { ITokenInfo } from "~/types/global"
import { IMessageGenieData } from "~/types/message-genie"
import { axiosInstance, retryFetch } from "~/utils/axios"

export async function generatePersona(
  tokenInfo: ITokenInfo,
  data: Omit<IMessageGenieData, "context" | "linkedin_new_connection_flag">,
  options: AxiosRequestConfig = {}
) {
  const url = `/tenants/${tokenInfo.tenant_id}/users/${tokenInfo.user_id}/persona/custom`
  return await axiosInstance({
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`,
      "Content-Type": "application/json"
    },
    data,
    ...options
  })
}

export async function emailGenieStream(
  tokenInfo: ITokenInfo,
  data: IMessageGenieData,
  linkedTenantId?: number
) {
  let url = `${URLS.V1}/tenants/${tokenInfo.tenant_id}/users/${tokenInfo.user_id}/email-genie/stream`
  if (linkedTenantId) {
    url += `?linked_tenant_id=${linkedTenantId}`
  }
  return await retryFetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  })
}
